import React, { useMemo } from 'react';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { RemoteCarousel, RootLayout } from 'common/components';
import { MODEL_JSON_STORE_NAME, Offers, selectBreadcrumbs, useModelJsonSelector } from 'modules/model-json';
import { State } from 'store/types';
import { convertProducts } from 'utils';
import {
  AdviceSection,
  BannersSection,
  CategoriesSection,
  DesignProjectGallery,
  HeaderSection,
  SeedsSection,
} from './components';
import { GARDEN_PATH } from './garden-constants';

/**
 * Вью страницы "Товары для сада и огорода"
 */
export const Garden: React.FC = () => {
  const { modelJson } = useStoreon<State>(MODEL_JSON_STORE_NAME);
  const breadcrumbs = React.useMemo(() => selectBreadcrumbs(modelJson), [modelJson]);
  const modifiedBreadcrumbs = useMemo(() => breadcrumbs?.slice(0, 1), [breadcrumbs]);

  const { showSeeds, offers } = useModelJsonSelector();

  const productsOffers = offers as Offers[];

  return (
    <RootLayout currentPage={GARDEN_PATH} customBreadcrumbs={modifiedBreadcrumbs}>
      <Layout>
        <HeaderSection />
        <CategoriesSection />
        {showSeeds ? <SeedsSection /> : <DesignProjectGallery />}

        {productsOffers && productsOffers.length === 2 && (
          <RemoteCarousel
            elementBlock="landingSad"
            productIdList={convertProducts(productsOffers[0].products)}
            remoteId="bestsellersCarousel"
            seeMoreLink={productsOffers[0].link}
            showSeeMore
            title={productsOffers[0].title}
          />
        )}

        <BannersSection />

        {offers && productsOffers.length === 2 && (
          <RemoteCarousel
            elementBlock="landingSad"
            productIdList={convertProducts(productsOffers[1].products)}
            remoteId="noveltiesCarousel"
            seeMoreLink={productsOffers[1].link}
            showSeeMore
            title={productsOffers[1].title}
          />
        )}

        <AdviceSection />
      </Layout>
    </RootLayout>
  );
};
